import _decorate from "@babel/runtime/helpers/esm/decorate";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "@babel/runtime/helpers/esm/get";
let _ = t => t,
  _t,
  _t2,
  _t3;
function _superPropGet(t, e, r, o) { var p = _get(_getPrototypeOf(1 & o ? t.prototype : t), e, r); return 2 & o ? function (t) { return p.apply(r, t); } : p; }
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { html } from 'lit';
import { property, state } from 'lit/decorators.js';
import CDSLink from '@carbon/web-components/es/components/link/link.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import { ICON_PLACEMENT } from "../../globals/defs.js";
import StableSelectorMixin from "../../globals/mixins/stable-selector.js";
import styles from "././link-with-icon.css.js";
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';
import CTAMixin from "../../component-mixins/cta/cta.js";
import { CTA_TYPE } from "../cta/defs.js";
export { ICON_PLACEMENT };
const {
  prefix,
  stablePrefix: c4dPrefix
} = settings;

/**
 * Link with icon.
 *
 * @element c4d-link-with-icon
 * @slot icon - The icon.
 * @slot icon-left - The CTA icon to place at the left.
 * @csspart span - The span element. Usage: `c4d-lightbox-video-player::part(span)`
 */
let C4DLinkWithIcon = _decorate([customElement(`${c4dPrefix}-link-with-icon`)], function (_initialize, _CTAMixin) {
  class C4DLinkWithIcon extends _CTAMixin {
    constructor(...args) {
      super(...args);
      _initialize(this);
    }
  }
  return {
    F: C4DLinkWithIcon,
    d: [{
      kind: "field",
      decorators: [property({
        attribute: 'icon-placement',
        reflect: true
      })],
      key: "iconPlacement",
      value() {
        return ICON_PLACEMENT.RIGHT;
      }
    }, {
      kind: "field",
      decorators: [property({
        type: Boolean
      })],
      key: "iconInline",
      value() {
        return true;
      }
    }, {
      kind: "field",
      decorators: [property()],
      key: "size",
      value() {
        return 'lg';
      }
    }, {
      kind: "field",
      decorators: [state()],
      key: "_hasContent",
      value() {
        return false;
      }
    }, {
      kind: "method",
      key: "_handleSlotChange",
      value:
      /**
       * Icon placement(right (default) | left)
       */

      /**
       * Positions the icon inline with text when `true`
       */

      /**
       * Property that specifies the link to use size large
       *
       * @internal
       */

      /**
       * `true` if there is a non-empty default slot content.
       */

      /**
       * Handles `slotchange` event on the default `<slot>`.
       */
      function _handleSlotChange({
        target
      }) {
        this._hasContent = target.assignedNodes().some(node => {
          var _node$nodeValue;
          return node.nodeType !== Node.COMMENT_NODE && (node.nodeType !== Node.TEXT_NODE || ((_node$nodeValue = node.nodeValue) === null || _node$nodeValue === void 0 ? void 0 : _node$nodeValue.trim()));
        });
      }
    }, {
      kind: "method",
      key: "_renderContent",
      value: function _renderContent() {
        const {
          ctaType,
          _hasContent: hasContent
        } = this;
        if (ctaType !== CTA_TYPE.VIDEO) {
          return html(_t || (_t = _`<span part="span"><slot></slot></span>`));
        }
        const {
          videoDuration,
          videoName,
          formatVideoCaption: formatVideoCaptionInEffect,
          formatVideoDuration: formatVideoDurationInEffect
        } = this;
        const caption = hasContent ? undefined : formatVideoCaptionInEffect({
          duration: formatVideoDurationInEffect({
            duration: !videoDuration ? videoDuration : videoDuration * 1000
          }),
          name: videoName
        });
        return html(_t2 || (_t2 = _`
      <span
        ><slot @slotchange="${0}"></slot>${0}</span
      >
    `), this._handleSlotChange, caption);
      }
    }, {
      kind: "method",
      key: "_renderInner",
      value: function _renderInner() {
        return html(_t3 || (_t3 = _` ${0}${0} `), this._renderContent(), this._renderIcon());
      }
    }, {
      kind: "method",
      key: "updated",
      value: function updated(changedProperties) {
        _superPropGet(C4DLinkWithIcon, "updated", this, 3)([changedProperties]);
        const {
          iconInline,
          iconPlacement,
          _linkNode: linkNode
        } = this;
        if (linkNode) {
          linkNode.classList.add(`${prefix}--link-with-icon`);
          linkNode.classList.toggle(`${prefix}--link-with-icon__icon-${ICON_PLACEMENT.LEFT}`, iconPlacement === ICON_PLACEMENT.LEFT);
          linkNode.classList.toggle(`${prefix}--link-with-icon__icon-${ICON_PLACEMENT.RIGHT}`, iconPlacement === ICON_PLACEMENT.RIGHT);
          if (iconInline && iconPlacement === ICON_PLACEMENT.RIGHT) {
            linkNode.classList.add(`${prefix}--link-with-icon--inline-icon`);
          }
        }
      }
    }, {
      kind: "get",
      static: true,
      key: "stableSelector",
      value: function () {
        return `${c4dPrefix}--link-with-icon`;
      }
    }, {
      kind: "field",
      static: true,
      key: "styles",
      value() {
        return styles;
      }
    }]
  };
}, CTAMixin(StableSelectorMixin(CDSLink)));
/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DLinkWithIcon;
//# sourceMappingURL=link-with-icon.js.map
